/*
 * @Author: hzm
 * @Date: 2022-11-22 07:57:38
 * @Description:
 */

import axios from "axios";
import type { AxiosResponse } from "axios";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type {
  RequestConfig,
  RequestInterceptors,
  CancelRequestSource,
} from "./types";
import { tansParams, blobValidate } from "../utils";
import cache from "../cache";
import { modal } from "../message";
import { errorCode } from "./errorCode";
import { saveAs } from "file-saver";
class Request {
  // axios 实例
  instance: AxiosInstance;
  // 拦截器对象
  interceptorsObj?: RequestInterceptors<AxiosResponse>;

  cancelRequestSourceList?: CancelRequestSource[];

  requestUrlList?: string[];

  constructor(config: RequestConfig) {
    this.requestUrlList = [];
    this.cancelRequestSourceList = [];
    this.instance = axios.create(config);
    this.interceptorsObj = config.interceptors;
    // 拦截器执行顺序 接口请求 -> 实例请求 -> 全局请求 -> 实例响应 -> 全局响应 -> 接口响应
    this.instance.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        // console.log("config: ", config);
        // 是否需要设置 token


        // 是否需要防止数据重复提交
        const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
        if (!config.headers?.['Content-Type'] && !config.headers?.['content-type']) {
          config.headers['Content-Type'] = 'application/json;charset=utf-8';
        }

        // 

        // get请求映射params参数

        if (config.method === "get" && config.params) {
          let url = config.url + "?" + tansParams(config.params);
          url = url.slice(0, -1);
          config.params = {};
          config.url = url;
        }
        if (
          !isRepeatSubmit &&
          (config.method === "post" || config.method === "put")
        ) {
          const requestObj = {
            url: config.url,
            data:
              typeof config.data === "object"
                ? JSON.stringify(config.data)
                : config.data,
            params:
              typeof config.params === "object"
                ? JSON.stringify(config.params)
                : config.params,
            time: new Date().getTime(),
          };
          console.log("s_url: ", config.url);
          const sessionObj = cache.session.getJSON("sessionObj");
          if (
            sessionObj === undefined ||
            sessionObj === null ||
            sessionObj === ""
          ) {
            cache.session.setJSON("sessionObj", requestObj);
          } else {
            const s_url = sessionObj.url; // 请求地址
            const s_data = sessionObj.data; // 请求数据
            const s_params = sessionObj.params; // 请求数据
            const s_time = sessionObj.time; // 请求时间
            const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
            if (
              s_data === requestObj.data &&
              requestObj.time - s_time < interval &&
              s_url === requestObj.url &&
              s_params === requestObj.params
            ) {
              const message = "数据正在处理，请勿重复提交";
              console.warn(`[${s_url}]: ` + message);
              return Promise.reject(new Error(message));
            } else {
              cache.session.setJSON("sessionObj", requestObj);
            }
          }
        }
        return config;
      },
      (err: any) => err
    );

    // 使用实例拦截器
    this.instance.interceptors.request.use(
      this.interceptorsObj?.requestInterceptors,
      this.interceptorsObj?.requestInterceptorsCatch
    );
    this.instance.interceptors.response.use(
      this.interceptorsObj?.responseInterceptors,
      this.interceptorsObj?.responseInterceptorsCatch
    );
    // 全局响应拦截器保证最后执行
    this.instance.interceptors.response.use(
      // 因为我们接口的数据都在res.data下，所以我们直接返回res.data
      (res: AxiosResponse) => {
        return res;
      },
      async (error: any) => {
        console.log("err" + error);
        let { message } = error;
        console.log("message: ", message);

        if (message == "Network Error") {
          message = "后端接口连接异常";
        } else if (message?.includes?.("timeout")) {
          message = "系统接口请求超时";
        } else if (message?.includes?.("Request failed with status code")) {
          message = "系统接口" + message.substr(message.length - 3) + "异常";
        }

        message && modal.msgError(message);
        return Promise.reject(error);
      }
    );
  }
  /**
   * @description: 获取指定 url 在 cancelRequestSourceList 中的索引
   * @param {string} url
   * @returns {number} 索引位置
   */
  private getSourceIndex(url: string): number {
    return this.cancelRequestSourceList?.findIndex(
      (item: CancelRequestSource) => {
        return Object.keys(item)[0] === url;
      }
    ) as number;
  }
  /**
   * @description: 删除 requestUrlList 和 cancelRequestSourceList
   * @param {string} url
   * @returns {*}
   */
  private delUrl(url: string) {
    const urlIndex = this.requestUrlList?.findIndex((u) => u === url);
    const sourceIndex = this.getSourceIndex(url);
    // 删除url和cancel方法
    urlIndex !== -1 && this.requestUrlList?.splice(urlIndex as number, 1);
    sourceIndex !== -1 &&
      this.cancelRequestSourceList?.splice(sourceIndex as number, 1);
  }



  request<T>(config: RequestConfig<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      // 如果我们为单个请求设置拦截器，这里使用单个请求的拦截器
      if (config.interceptors?.requestInterceptors) {
        config = config.interceptors.requestInterceptors(config);
      }
      const url = config.url;
      // url存在保存取消请求方法和当前请求url
      if (url) {
        this?.requestUrlList?.push(url);
        // TODO 在axios0.22起，对CancelToken已经弃用，需要改成  AbortController 文档：https://axios-http.com/docs/cancellation
        config.cancelToken = new axios.CancelToken((c) => {
          this?.cancelRequestSourceList?.push({
            [url]: c,
          });
        });
      }
      this.instance
        .request<any, T>(config)
        .then((res) => {
          // 如果我们为单个响应设置拦截器，这里使用单个响应的拦截器
          if (config.interceptors?.responseInterceptors) {
            res = config.interceptors.responseInterceptors(res);
          }

          resolve(res);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => {
          url && this.delUrl(url);
        });
    });
  }


  // 取消请求
  cancelRequest(url: string | string[]) {
    if (typeof url === "string") {
      // 取消单个请求
      const sourceIndex = this.getSourceIndex(url);
      sourceIndex >= 0 && this.cancelRequestSourceList?.[sourceIndex][url]();
    } else {
      // 存在多个需要取消请求的地址
      url.forEach((u) => {
        const sourceIndex = this.getSourceIndex(u);
        sourceIndex >= 0 && this.cancelRequestSourceList?.[sourceIndex][u]();
      });
    }
  }
  // 取消全部请求
  cancelAllRequest() {
    this.cancelRequestSourceList?.forEach((source) => {
      const key = Object.keys(source)[0];
      source[key]();
    });
  }

  // 导出请求
  async exportRequest(config: RequestConfig) {
    config.headers = config.headers || {};
    config.headers["Content-Type"] = "multipart/form-data";
    config.responseType = "blob";
    return this.request(config);
  }

  // 图片blob 处理
  async blobRequest(config: RequestConfig) {
    config.responseType = "blob";
    return this.request(config);
  }



  downloadRequest = async (
    url: string,
    data: ObjType,
    filename: string
  ): Promise<any> => {
    const downloadLoadingInstance = (await modal).ElLoading.service({
      text: "正在下载数据，请稍候",
      background: "rgba(0, 0, 0, 0.7)",
    });


    return this.instance
      .post(url, data, {
        // transformRequest: [
        //   (params) => {
        //     return tansParams(params);
        //   },
        // ],
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob",
      })
      .then(async (data: any) => {
        const isLogin = await blobValidate(data);
        if (isLogin) {
          const blob = new Blob([data]);
          saveAs(blob, filename);
        } else {
          const resText = await data.text();
          const rspObj = JSON.parse(resText);
          const errMsg =
            errorCode[rspObj.code] || rspObj.msg || errorCode["default"];
          (await modal).msgError(errMsg);
        }
        downloadLoadingInstance.close();
      })
      .catch(async (r: any) => {
        console.error(r);
        (await modal).msgError("下载文件出现错误，请联系管理员！");
        downloadLoadingInstance.close();
      });
  }
}

export { Request, RequestConfig, RequestInterceptors };
